<template>
  <section
    id="section-top"
    class="home-image-jumbo"
    :class="{ fullwidth: backgroundImage.fullwidth }"
  >
  <!-- Section with 2 columns (not fullwidth image) -->
    <div
      v-if="!backgroundImage.fullwidth"
      class="image"
      :style="{ backgroundImage: `url(${backgroundImage.src})` }"
    >
    </div>
    <div v-if="!backgroundImage.fullwidth" class="content">
      <h1>{{ headingText }}</h1>
      <div class="large" v-if="extraText" v-html="extraText"></div>
      <p v-if="callToActionLabel" class="cta-container">
        <CTA :smooth=true :text="callToActionLabel" href="#start" />
      </p>
    </div>
  <!-- Section with full width image-->
    <div
      v-if="backgroundImage.fullwidth"
      class="image"
      :style="{ backgroundImage: `url(${backgroundImage.src})` }"
    >
      <div class="content">
        <h1>{{ headingText }}</h1>
        <div class="large" v-if="extraText" v-html="extraText"></div>
      </div>
      <p v-if="callToActionLabel" class="cta-container">
        <CTA :smooth=true :text="callToActionLabel" href="#start" />
      </p>
    </div>
  </section>
</template>

<script>
import CTA from "@/components/CTA.vue"

export default {
  name: "section-top",
  props: {
    backgroundImage: { src: String, fullwidth: Boolean },
    headingText: String,
    extraText: String,
    callToActionLabel: String,
  },
  components: {
    CTA,
  },
}
</script>

<style lang="scss" scoped>
  .home-image-jumbo {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-content: stretch;
    align-items: center;
    max-width: 1800px;
    margin: 0 auto 0 auto;
    padding: 0 60px 50px 60px;

    .image {
      height: calc(100vw / 2);
      width: 100%;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;

      margin-bottom: -200px;

      @media screen and (max-width: 1500px) {
        margin-bottom: -150px;
      }
      @media screen and (max-width: $break-mobile) {
        margin-bottom: 0;
      }

    }

    .content {
      margin-top: 60px;
      margin-left: 5%;
      width: 40%;
    }

    &.fullwidth {
      padding: 0;
      max-width: unset;
      .image {
        background-position: top left;
        margin-bottom: 1vw;
      }
      .content {
        margin: 60px 0 0 60%;
        width: 530px;
      }

      .cta-container {
        margin: 60px 0 0 70%;
      }
    }

    @media screen and (max-width: 2100px) {
      padding-top: 75px;
      align-items: flex-start;

      .content {
        margin-top: 0;
        margin-left: 2%;
        width: 60%;
      }

      &.fullwidth {
        .content {
          margin: 150px 0 0 60%;
        }
      }

    }

    @media screen and (max-width: $break-container) {
      align-items: flex-start;
      padding-top: 100px;

      .content {
        width: 60%;
        margin-left: 25px;

        h1 {
          font-size: 40px;
        }

        .large p {
          font-size: 15px;
        }
      }


      &.fullwidth {
        .content {
          width: 400px;
        }
        .cta-container {
          display: none;
        }
      }
    }

    @media screen and (max-width: $break-mobile) {
      flex-flow: column nowrap;
      margin-top: 0;
      margin-bottom: 50px;
      padding: 0;

      .image {
        height: 100vw;
        background-size: cover;
      }

      .content {
        margin-top: -25vw;
        padding: 0 12vw;
        width: auto;

        h1 {
          font-size: 40px;
        }
      }

     &.fullwidth {
        margin-bottom: 80px;
        .image {
          background-size: contain;
        }

        .content {
          margin: 90vw 0 0 15px;
          padding: 0;
        }
        h1 {
        }
      }
    }

    @media screen and (max-width: 650px) {
      &.fullwidth {
        .image {
          margin: 0;
        }
        .content {
          width: 80%;
        }
        h1 {
          font-size: 30px;
        }
      }
    }

  }

  [dir="rtl"] #section-top.home-image-jumbo {
    direction: ltr;

    .content {
      direction: rtl;
    }

  }

</style>
